import React from 'react';
import FlexibleTable from '@/stories/Components/FlexibleTable/FlexibleTable';
import { useTranslations } from 'use-intl';
import { toTranslationKey } from '@/utils/translations';
import ExpandableTable from './ExpandableTable';

interface HeaderProps {
	header: any;
}

const Header: React.FC<HeaderProps> = ({ header }) => {
	const t = useTranslations('CreditBureau');
	if (!header) return null;

	// Create a new object with translated keys
	const translatedData = Object.entries(header)
		.filter(([key]) => key !== '__typename')
		.reduce(
			(acc, [key, value]) => {
				const translatedKey = t(toTranslationKey(key));
				acc[translatedKey] = value;
				return acc;
			},
			{} as Record<string, any>
		);

	return (
		<ExpandableTable title={t('Header')}>
			<div className="max-w-4xl">
				<FlexibleTable flipped data={translatedData} />
			</div>
		</ExpandableTable>
	);
};

export default Header;
